import {
  ExampleImageListWithoutStyle,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import {
  withOverridableStyles,
} from '@bingads-webui-campaign-react/ads-studio-shared-components';
import { useExampleImageListStyles } from './style';

export const ExampleImageList = withOverridableStyles(ExampleImageListWithoutStyle, useExampleImageListStyles);
